import React, { useContext, useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'

import useAsyncCallback from '../../../Utils/Hooks/useAsyncCallback'
import useTranslate from '../../../Utils/Hooks/useTranslate'

import OrganizationContext from '../../../State/Organization/Context'
import ModalContext from '../../../State/Modal/Context'
import UserContext from '../../../State/User/Context'
import TableContext from '../../../State/Table/Context'
import useErrorNotifier from '../../../Utils/Hooks/useErrorNotifier'

import ModalContent from '../../Modal/Components/ModalContent'
import ModalFooter from '../../Modal/Components/ModalFooter'
import SubmitButton from '../../Modal/Components/SubmitButton'
import Button from '../../Button'

const OrganizationsArchive = () => {
  const { actions: { updateOrganizations, clearCheckedUsers } } = useContext(OrganizationContext)
  const { selectors: { getSelectedCheckboxes } } = useContext(TableContext)
  const { actions: { closeModal, setSubmitted } } = useContext(ModalContext)
  const { actions: { updatePermissionOrganizationStatus } } = useContext(UserContext)
  const [checkedOrganizations, setCheckedOrganizations] = useState(getSelectedCheckboxes())
  const shouldActivate = checkedOrganizations.every(org => org.status === 'archived')
  const translate = useTranslate(!shouldActivate ? 'deactivateOrganizationsModal' : 'reactivateOrganizationsModal')
  const [execute, , isLoading, result, hasError] = useAsyncCallback(updateOrganizations)
  const [executeUpdateStatus, , isStatusLoading, statusResult, hasStatusError] = useAsyncCallback(updatePermissionOrganizationStatus)
  useErrorNotifier(hasError, result)
  useErrorNotifier(hasStatusError, statusResult)
  const labels = {
    submittingLabel: translate('labels.submitting'),
    buttonLabel: translate('labels.submit')
  }

  const notificationMessages = {
    operationSuccess: translate('notifications.success'),
    operationFailure: translate('notifications.fail')
  }

  useEffect(() => {
    setCheckedOrganizations(getSelectedCheckboxes())
  }, [result, hasError])

  const handleClick = async () => {
    await execute(checkedOrganizations, notificationMessages)
    await executeUpdateStatus(checkedOrganizations)
    closeModal()
    setSubmitted()
    clearCheckedUsers()
  }

  return (
    <>
      <ModalContent>
        <p>{translate('copy')}</p>
        {!shouldActivate && <ReactMarkdown>{translate('invitesCopy')}</ReactMarkdown>}
      </ModalContent>
      <ModalFooter>
        <Button onClick={closeModal} inverted data-testid="remove-invite-link-cancel">{translate('labels.cancel')}</Button>
        <SubmitButton handleSubmit={handleClick} labels={labels} isSubmitting={isLoading || isStatusLoading} testIdRoot="remove-invite-link" />
      </ModalFooter>
    </>
  )
}

export default OrganizationsArchive
